module.exports = __webpack_public_path__ + "static/img/Xeo-Logo-White.9f4b5e1b.png";